import createOnHandler from '@glass/common/modules/utils/createOnHandler';
import { CREATE_ACCOUNT_ACTION } from '@glass/web/modules/auth/authActionTypes';
import { PASSWORD_AUTH_VIEW } from '@glass/web/modules/authForm/authViews';

import createUserAction from '@glass/shared/modules/auth/createUserAction';
// eslint-disable-next-line import/no-cycle
import handleCreateUserErrorAction from '@glass/shared/modules/authForm/actions/handleCreateUserErrorAction';
import promptAuthAction from '@glass/shared/modules/authForm/actions/promptAuthAction';

const createEmailSignupAction = (options) => (authForm) => (dispatch) => {
  const { requirePassword, onAuth } = options;
  return dispatch(createUserAction(authForm))
    .then((user) => {
      if (requirePassword) {
        return dispatch(
          promptAuthAction({
            email: user.email,
            view: PASSWORD_AUTH_VIEW,
            actionType: CREATE_ACCOUNT_ACTION,
          }),
        );
      }
      return createOnHandler(onAuth)(user);
    })
    .catch((error) => dispatch(handleCreateUserErrorAction(error, options, authForm)));
};

export default createEmailSignupAction;
